import { TableRow } from './input/table-row';
import { TableEventTargetType } from '../enum/table-event-target-type';

export class TableOutputRowEvent {
    row: TableRow;
    type: 'CLICK' | 'MOUSEENTER' | 'MOUSE_LEAVE';
    targetType: TableEventTargetType;

    public isDataRowTarget(): boolean {
        return (this.targetType === TableEventTargetType.DATA_ROW) ? true : false;
    }

    public isHeaderTarget(): boolean {
        return (this.targetType === TableEventTargetType.HEADER) ? true : false;
    }
}
